module.exports = __webpack_public_path__ + "static/pixie-cli-287ae004fd2d18e4ebdeb95b8f134cc1.webm";